// extracted by mini-css-extract-plugin
var _1 = "Comment-module__animateUploadProgressBarWidth--EiP9P";
var _2 = "Comment-module__animatedBackground--rZsY4";
var _3 = "Comment-module__comment--KEQRz";
var _4 = "Comment-module__commentActions--oyYTr";
var _5 = "Comment-module__commentButton--U_iUf";
var _6 = "Comment-module__commentContent--qMUFO";
var _7 = "Comment-module__commentLeft--x0G9i";
var _8 = "Comment-module__commentMeta--at66F";
var _9 = "4px";
var _a = "Comment-module__commentReactions--nLyAs";
var _b = "Comment-module__commentRight--ffWFX";
var _c = "Comment-module__commentRightSheet--hX_jH";
var _d = "Comment-module__editing--Obr9W";
var _e = "Comment-module__editingActions--hdkA4";
var _f = "Comment-module__first--J8ywp";
var _10 = "Comment-module__hasExtraBottomPadding--wCjnK";
var _11 = "Comment-module__last--hpU_m";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "comment", _4 as "commentActions", _5 as "commentButton", _6 as "commentContent", _7 as "commentLeft", _8 as "commentMeta", _9 as "commentMetaMarginBottom", _a as "commentReactions", _b as "commentRight", _c as "commentRightSheet", _d as "editing", _e as "editingActions", _f as "first", _10 as "hasExtraBottomPadding", _11 as "last" }
